import React from "react";
import "./Timeline.css";

const Timeline = ({ experiences, theme }) => {
  return (
    <div className="timeline-container">
      <div className="timeline">
        {experiences.map((experience, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
          >
            <div className="timeline-content">
              <div
                className="timeline-card"
                style={{ borderColor: theme.imageHighlight }}
              >
                <div className="timeline-header">
                  <div className="company-logo">
                    <img
                      src={require(`../../assests/images/${experience.logo_path}`)}
                      alt={experience.company}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                  <div className="timeline-info">
                    <h3
                      className="timeline-title"
                      style={{ color: theme.text }}
                    >
                      {experience.title}
                    </h3>
                    <h4
                      className="timeline-company"
                      style={{ color: theme.imageHighlight }}
                    >
                      {experience.company}
                    </h4>
                    <div className="timeline-duration-container">
                      <span
                        className="timeline-duration-badge"
                        style={{
                          color: theme.text,
                          backgroundColor: theme.imageHighlight + "20",
                        }}
                      >
                        {experience.duration.replace(
                          /(January|February|March|April|May|June|July|August|September|October|November|December)/g,
                          (match) => {
                            const monthMap = {
                              January: "Jan",
                              February: "Feb",
                              March: "Mar",
                              April: "Apr",
                              May: "May",
                              June: "Jun",
                              July: "Jul",
                              August: "Aug",
                              September: "Sep",
                              October: "Oct",
                              November: "Nov",
                              December: "Dec",
                            };
                            return monthMap[match];
                          }
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="timeline-description"
                  style={{ color: theme.text }}
                >
                  {experience.description.split("\n").map((line, index) => (
                    <div key={index} className="timeline-bullet-point">
                      {line.replace(/^•\s*/, "")}
                    </div>
                  ))}
                </div>
                {experience.company_url && (
                  <a
                    href={experience.company_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="timeline-link"
                    style={{ color: theme.imageHighlight }}
                  >
                    Visit Website →
                  </a>
                )}
              </div>
            </div>
            <div
              className="timeline-marker"
              style={{ backgroundColor: theme.imageHighlight }}
            >
              <div className="timeline-marker-inner"></div>
              <div className="timeline-date" style={{ color: theme.text }}>
                {new Date(experience.duration.split(" - ")[0]).getFullYear()}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
